export default __webpack_public_path__ + "static/media/english-to-hungarian-mobile-2.2b0089e8.png";